function wrapRenueBlueMentions() {
  // Find all elements with class 'instastory-title'
  const instastoryElements = document.querySelectorAll('.instastory-title');
  
  instastoryElements.forEach(element => {
    // Get the text content of the element
    let textContent = element.innerHTML;
    
    // Check if the text contains '@renueblue'
    if (textContent.includes('@renueblue')) {
      // Replace '@renueblue' with an anchor tag that opens in new tab
      textContent = textContent.replace(
        /@renueblue/g,
        '<a href="https://www.instagram.com/renueblue/" target="_blank" rel="noopener noreferrer">@renueblue</a>'
      );
      
      // Update the element's HTML
      element.innerHTML = textContent;
    }
  });
}

function waitForInstastoryElements() {
  // Check if .instastory-title elements exist
  const instastoryElements = document.querySelectorAll('.instastory-title');
  
  if (instastoryElements.length > 0) {
    // Elements found, run the function
    wrapRenueBlueMentions();
  } else {
    // Elements not found yet, check again in 100ms
    setTimeout(waitForInstastoryElements, 100);
  }
}

// Start waiting for .instastory-title elements when DOM is loaded
document.addEventListener('DOMContentLoaded', waitForInstastoryElements);

// Also start waiting immediately in case the DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForInstastoryElements);
} else {
  waitForInstastoryElements();
}
